const url = "/api/v1/trial_offers";

export interface TrialOffersUpdateParams {
  code: string;
}

export const trialOffersUpdateQuery = (params: TrialOffersUpdateParams) => ({
  url,
  method: "PATCH",
  body: params,
});

interface ValidResponse {
  id: string;
  key: "valid";
  message: string;
}

interface OtherResponse {
  key: "invalid" | "already_used";
  message: string;
}

interface TrialOfferSerializer {
  data: {
    attributes: ValidResponse | OtherResponse;
  };
}

export type TrialOffersUpdateResponse = TrialOfferSerializer;
